<template>
  <div>
    <b-row>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.algorithm_caption"
          label-for="algorithm_caption"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.algorithm_caption"
            :rules="$v.algorithm_caption.$params"
          />
          <b-form-input
            id="algorithm_caption"
            type="text"
            :state="
              $v.algorithm_caption.$dirty ? !$v.algorithm_caption.$error : null
            "
            v-model="$v.algorithm_caption.$model"
          />

          <b-form-invalid-feedback id="algorithm_caption-feedback">
            {{ $lang.error_required | replace($lang.algorithm_caption) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.algorithm_name"
          label-for="algorithm_name"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.algorithm_name"
            :rules="$v.algorithm_name.$params"
          />
          <b-form-input
            id="algorithm_name"
            type="text"
            :state="$v.algorithm_name.$dirty ? !$v.algorithm_name.$error : null"
            v-model="$v.algorithm_name.$model"
          />

          <b-form-invalid-feedback id="algorithm_name-feedback">
            {{ $lang.error_required | replace($lang.algorithm_name) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.azmoonLang.algorithm_list_fields.question_count"
          label-for="question_count"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.algorithm_list_fields.question_count"
            :rules="$v.question_count.$params"
          />
          <b-form-input
            id="question_count"
            type="number"
            :state="$v.question_count.$dirty ? !$v.question_count.$error : null"
            v-model="$v.question_count.$model"
          />

          <b-form-invalid-feedback id="name-feedback">
            {{
              $lang.error_required
                | replace($lang.azmoonLang.algorithm_list_fields.question_count)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <requiredComponent
          slot="label"
          :label="$lang.azmoonLang.questions_kind"
          :rules="$v.question_kind_selected.$params"
        />
        <selectFind
          :options="question_kind_options"
          v-model="$v.question_kind_selected.$model"
          label="text"
          :isValid="
            $v.question_kind_selected.$dirty
              ? !$v.question_kind_selected.$error
              : null
          "
        />
        <b-form-invalid-feedback
          :state="
            $v.question_kind_selected.$dirty
              ? !$v.question_kind_selected.$error
              : null
          "
        >
          {{ $lang.error_required | replace($lang.azmoonLang.questions_kind) }}
        </b-form-invalid-feedback>
      </b-col>
      <b-col cols="12" md="12" v-if="mode === 'edit'">
        <b-form-group
          :label="$lang.azmoonLang.status"
          label-for="status"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.status"
            :rules="$v.is_enable.$params"
          />
          <b-form-checkbox
            v-model="$v.is_enable.$model"
            name="check-button"
            switch
          >
            <b
              v-if="$v.is_enable.$model"
              v-text="'فعال'"
              class="text-success"
            />
            <b v-else v-text="'غیرفعال'" class="text-danger" />
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        class="text-right mt-3"
        v-if="isAdmin(parentPermissions)"
      >
        <b-button variant="success" @click="submit">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, isAdmin } from "@/shared/utils";

export default {
  name: "register-analysis-algorithm-form",
  validations: {
    algorithm_caption: { required },
    algorithm_name: { required },
    question_count: { required },
    question_kind_selected: { required },
    is_enable: {},
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      algorithm_caption: null,
      algorithm_name: null,
      question_count: null,
      question_kind_selected: null,
      is_enable: false,
    };
  },
  computed: {
    question_kind_options() {
      return renderEumOptions("question_kind");
    },
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    pathOr,
    includes,
    renderEumOptions,
    isAdmin,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      const payload = {
        algorithm_caption: this.algorithm_caption,
        algorithm_name: this.algorithm_name,
        question_count: this.question_count,
        question_kind_id: pathOr(null, ["value"], this.question_kind_selected),
        is_enable: this.is_enable ? 1 : 0,
      };
      if (this.mode === "add") {
        delete payload.is_enable;
      }
      this.$emit("submit", payload);
    },
    close() {
      this.$emit("close");
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.algorithm_caption = pathOr(null, ["algorithm_caption"], this.item);
        this.algorithm_name = pathOr(null, ["algorithm_name"], this.item);
        this.question_count = pathOr(null, ["question_count"], this.item);
        this.question_kind_selected = this.question_kind_options.find(
          (item) =>
            item.value === pathOr(null, ["question_kind", "id"], this.item)
        );
        this.is_enable = !!pathOr(false, ["is_enable"], this.item);
      }
    },
  },
};
</script>
